import { objectSpread2 as _objectSpread2, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useField } from 'informed';

function Hidden(props) {
  var _useField = useField(_objectSpread2({
      type: 'text'
    }, props)),
    informed = _useField.informed,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  return render( /*#__PURE__*/React.createElement("input", _extends({}, informed, userProps, {
    ref: ref,
    type: "hidden"
  })));
}

export { Hidden };
